
import { ChecklistSuggestion } from "Models/Checklists/ChecklistSuggestion";
import { ChecklistTemplate } from "Models/Checklists/ChecklistTemplate";
import { DataState } from "Models/Common/DataState";
import { PagedResult } from "Models/Common/PagedResult";
import { Action } from "redux";
import { ChecklistTemplateFilterState } from "./ChecklistTemplateFilterState";

export const enum ActionTypes {
    CHECKLIST_SUGGESTIONS_RETRIEVED = "CHECKLIST_SUGGESTIONS_RETRIEVED",
    CHECKLIST_SUGGESTION_RETRIEVED = "CHECKLIST_SUGGESTION_RETRIEVED",
    CLEAR_CHECKLIST_TEMPLATES = "CLEAR_CHECKLIST_TEMPLATES",
    CHECKLIST_FILTER_UPDATED = "CHECKLIST_FILTER_UPDATED",
    CHECKLIST_TEMPLATE_SAVED = "CHECKLIST_TEMPLATE_SAVED",
    CHECKLIST_TEMPLATE_DELETED = "CHECKLIST_TEMPLATE_DELETED",
    CHECKLIST_PAGE_RETRIEVED = "CHECKLIST_PAGE_RETRIEVED",
    CHECKLIST_TEMPLATE_STATE_CHANGED = "CHECKLIST_TEMPLATE_STATE_CHANGED",
    CHECKLIST_TEMPLATE_RETRIEVED = "CHECKLIST_TEMPLATE_RETRIEVED",
    SHOW_VALIDATION_ERRORS = "SHOW_VALIDATION_ERRORS",
    CLEAR_VALIDATION_ERRORS = "CLEAR_VALIDATION_ERRORS",
}

export interface ISuggestionsRetrievedAction extends Action {
    type: ActionTypes.CHECKLIST_SUGGESTIONS_RETRIEVED;
    data: ChecklistSuggestion[];
}

export interface IChecklistSuggestionRetrieved extends Action {
    type: ActionTypes.CHECKLIST_SUGGESTION_RETRIEVED;
    data: ChecklistSuggestion;
}

export interface IClearChecklistTemplateAction extends Action {
    type: ActionTypes.CLEAR_CHECKLIST_TEMPLATES;
}

export interface IChecklistFilterUpdatedAction extends Action {
    type: ActionTypes.CHECKLIST_FILTER_UPDATED;
    filter: ChecklistTemplateFilterState;
}

export interface IChecklistPageRetrievedAction extends Action {
    type: ActionTypes.CHECKLIST_PAGE_RETRIEVED;
    page: PagedResult<ChecklistTemplate>;
}

export interface IChecklistTemplateStateChangedAction extends Action {
    type: ActionTypes.CHECKLIST_TEMPLATE_STATE_CHANGED;
    checklistTemplateId?: number;
    newState: DataState;
}

export interface IChecklistTemplateRetrievedAction extends Action {
    type: ActionTypes.CHECKLIST_TEMPLATE_RETRIEVED;
    checklistTemplate: ChecklistTemplate;
}

export interface IChecklistTemplateRetrievedAction extends Action {
    type: ActionTypes.CHECKLIST_TEMPLATE_RETRIEVED;
    checklistTemplate: ChecklistTemplate;
}

export interface IShowValidationErrorsAction extends Action {
    type: ActionTypes.SHOW_VALIDATION_ERRORS;
    validationErrors: string[];
    checklistTemplateId?: number;
}

export interface IClearValidationErrorsAction extends Action {
    type: ActionTypes.CLEAR_VALIDATION_ERRORS;
    checklistTemplateId?: number;
}

export interface IChecklistTemplateSavedAction extends Action {
    type: ActionTypes.CHECKLIST_TEMPLATE_SAVED;
    checklistTemplate: ChecklistTemplate;
}

export interface IChecklistTemplateDeletedAction extends Action {
    type: ActionTypes.CHECKLIST_TEMPLATE_DELETED;
    checklistTemplateId: number;
}

export type ChecklistTemplateActions = ISuggestionsRetrievedAction | IChecklistSuggestionRetrieved | IClearChecklistTemplateAction | IChecklistFilterUpdatedAction | IChecklistPageRetrievedAction | IChecklistTemplateStateChangedAction | IChecklistTemplateRetrievedAction | IShowValidationErrorsAction | IClearValidationErrorsAction | IChecklistTemplateSavedAction | IChecklistTemplateDeletedAction;



// WEBPACK FOOTER //
// ./src/Store/ChecklistTemplates/ChecklistTemplateActionTypes.ts